export default __webpack_public_path__ + "static/media/MercaZMedellinSantaLucia.b45e192b.geojson";